import { AppBar, Backdrop, Card, CircularProgress, Container, Grid, makeStyles, Toolbar, Typography, FormControlLabel, Switch } from "@material-ui/core";
import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import ReactJson from 'react-json-view';
import { DRAWER_WIDTH } from '../Stepper/Sidebar';
import { CreateCardForm } from './CreateCardForm';
import { ExistingPaymentOptions } from './ExistingPaymentOptions';
import { useHistory, useLocation } from "react-router-dom";
import { cancelBooking, confirmBooking, createNewBooking, updateWhitelabelBookingDate } from 'services/booking.service';
import { useConfirm } from 'material-ui-confirm';
import voca from 'voca'
import isEmpty from 'lodash.isempty';
import { deleteCCPaymentMethod, setDefaultPaymentMethodLocal, setPaymentForRequest } from 'services/payments.service';
import { adjustTransactionState, bookingState, isWaitingForPollState, manualRefreshState, rebookedState, stepState } from '../RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { STEP_STATE_PAYMENT } from '../RecoilState';
import { Transaction } from '../Details/BookingDetail/Transaction';
import { isBookingConfirmed, isCancelled, isCompleted } from 'util/bookingStates';
import { CreateBraintreeDropin } from "./CreateBraintreeDropin";
import { CreateBraintreeCardForm } from "./CreateBraintreeCardForm";
const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexGrow: 1,

    },
    padded: {
      '& > *': {
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
          margin: theme.spacing(1)
        }

      },
    },
    top: {
      bottom: 'auto',
      top: 0,
      right: 'auto',
    },
    bottom: {
      top: 'auto',
      bottom: 0,
      right: 'auto',
    },
    fixed: {
      [theme.breakpoints.up('md')]: {
        left: DRAWER_WIDTH,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
      },
    },
    appBar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-evenly',
    },
    title: {
      flexGrow: 1
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }
})
const PaymentScreen = ({ match, location }) => {
  const classes = useStyles()
  const history = useHistory()
  const confirm = useConfirm()

  const [reloadHash, setReloadHash] = useState('');

  const setRebookedState = useSetRecoilState(rebookedState)
  const setStepState = useSetRecoilState(stepState)
  const setManualRefreshState = useSetRecoilState(manualRefreshState);
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);
  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);
  const [booking, setBooking] = useRecoilState(bookingState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setStepState(STEP_STATE_PAYMENT)
  }, []);

  const confirmDelete = useCallback(
    async (cardInfo) => {
      try {
        const cardMeta = cardInfo?.last4 ? [cardInfo?.label, voca.capitalize(cardInfo?.card_type), voca.capitalize(cardInfo?.type), `ending with ${cardInfo?.last4}`].filter(x => !isEmpty(x)).join(' ') : [cardInfo?.label, cardInfo?.email].filter(x => !isEmpty(x)).join(' ')
        await confirm({
          title: 'Delete Payment Method',
          description: `Are you sure you want to delete payment method ${cardMeta}? This action cannot be undone.`,
        })

        await deleteCCPaymentMethod(cardInfo?.token)
        await setDefaultPaymentMethodLocal(null)
        setReloadHash(new Date())
      } catch (e) {

      }
    },
    [confirm],
  );

  const onProcessPayment = useCallback(
    async (target) => {
      setLoading(true)
      try {
        const {
          bookingId,
          newDateTime,
          bookingParams,
          bookingClientId,
          cancellable
        } = { ...history?.location?.state }
        setIsWaitingForPoll(true)
        if (bookingParams && bookingClientId) {
          const newBookingParams = {
            ...bookingParams,
            payment_method_token: target?.token,
          }
          if (cancellable) {
            // const cancelResult = await cancelBooking(match.params.serviceId, `SYSTEM: rebooked to ${newBooking?.id}`)
            const cancelResult = await cancelBooking(match.params.serviceId)
          }
          const newBooking = await createNewBooking(bookingClientId, newBookingParams)

          const confirmNewBooking = await confirmBooking(newBooking?.id)
          setRebookedState(true)
          setAdjustTransaction(null)
          history.replace(`/bookings/${newBooking?.id}` + history.location.search)
        } else if (bookingId && newDateTime) {
          await updateWhitelabelBookingDate(bookingId, newDateTime)
          await setPaymentForRequest(bookingId, target?.token)
          setRebookedState(true)
          setAdjustTransaction(null)
          //TODO:CHECK: assume booking confirms on reschedule
          await confirmBooking(bookingId)
          history.replace(`/bookings/${bookingId}` + history.location.search)

        }
        else {
          await setPaymentForRequest(match.params.serviceId, target?.token)
          await confirmBooking(match.params.serviceId)
          setAdjustTransaction(null)
          history.push(`/bookings/${match.params.serviceId}` + history.location.search)
        }

        setManualRefreshState(Math.random())
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    },
    [history, match.params.serviceId],
  );

  const [abBraintree, setAbBraintree] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar elevation={0} position="static" color="default" className={clsx(classes.top, classes.appBar)}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Payment
          </Typography>
        </Toolbar>
      </AppBar>
      <Container >
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Card>
              {/* <FormControlLabel
                control={<Switch size="small" checked={abBraintree} onChange={()=>setAbBraintree(!abBraintree)} />}
                label="Braintree"
              /> */}
              {abBraintree ? (
                <CreateBraintreeCardForm
                  onSuccess={() => setReloadHash(new Date())}
                  onEnterCreateMode={() => setCreateMode(true)}
                  onExitCreateMode={() => setCreateMode(false)}
                />
              ) : (
                <CreateCardForm
                  onSuccess={() => setReloadHash(new Date())}
                  onEnterCreateMode={() => setCreateMode(true)}
                  onExitCreateMode={() => setCreateMode(false)}
                />
              )}
            </Card>
            {!createMode && (
              <ExistingPaymentOptions reloadHash={reloadHash}
                onDeleteOption={async (cardInfo) => confirmDelete(cardInfo)}
                onSelectOption={async (target) => {
                  onProcessPayment(target)
                }} target={location.state} />
            )}
          </Grid>
          <Grid item xs={12} md={5}>
            <Transaction booking={booking} readOnly />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export { PaymentScreen };
